import React from 'react';
import { format, Locale } from 'date-fns';
import { enGB, pl } from 'date-fns/locale';

const LOCALES: { [key: string]: Locale } = { pl, en: enGB };
export function useFormattedDate(date: Date | string, locale: string): string {
    if (!date) return '';
    return React.useMemo(() => format(new Date(date), 'd MMM yyyy', { locale: LOCALES[locale] }), [date, locale]);
}
